module.exports = "/img/16.cd87f3.webp";